(() => {
  window.HomConfiguratorMobile = {
    connect(host) {
      const media = matchMedia("(max-width: 700px)");
      const controls = host.querySelector(".hc-controls");
      const visual = host.querySelector(".hc-visual");
      const stage = host.querySelector(".hc-stage");
      const orderSummary = host.querySelector(".hc-summary");
      const bar = host.stickyBar;
      const abort = new AbortController();
      const options = { signal: abort.signal };
      const editableSelector = 'input[type="number"]:not([readonly]),textarea';
      const activeInput = () => {
        const input = document.activeElement;
        return media.matches &&
          host.contains(input) &&
          input.matches(editableSelector)
          ? input
          : null;
      };
      const groups = [];
      for (const card of [...controls.children]) {
        if (card.tagName !== "FIELDSET") continue;
        const legend = card.querySelector(":scope > legend");
        if (!legend) continue;
        const details = document.createElement("details");
        details.className = "hc-mobile-group";
        details.open = true;
        const summary = document.createElement("summary");
        const title = document.createElement("strong");
        const number = legend.querySelector(".hc-step");
        if (number) {
          const badge = number.cloneNode(true);
          const label = legend.cloneNode(true);
          label.querySelector(".hc-step").remove();
          const text = document.createElement("span");
          text.textContent = label.textContent.trim();
          title.append(badge, document.createTextNode(" "), text);
        } else {
          title.textContent = legend.textContent.trim();
        }
        const selection = document.createElement("span");
        selection.className = "hc-mobile-selection";
        summary.append(title, selection);
        card.before(details);
        details.append(summary, card);
        groups.push({ details, card, selection });
      }
      const choices = document.createElement("p");
      choices.className = "hc-mobile-choices";
      choices.setAttribute("aria-live", "polite");
      stage.after(choices);
      const choiceLabel = (name) => {
        const input = host.querySelector('[name="' + name + '"]:checked');
        if (!input || input.disabled) return "";
        const label = input.closest("label");
        if (!label) return "";
        const title = label.querySelector(".hn-profile-title");
        if (title) return title.textContent.trim();
        const copy = label.cloneNode(true);
        copy.querySelectorAll("input,small,svg").forEach((el) => el.remove());
        return copy.textContent.replace(/\s+/g, " ").trim();
      };
      const zoom = document.createElement("button");
      zoom.type = "button";
      zoom.className = "hc-mobile-zoom";
      zoom.textContent = host.dataset.zoomLabel;
      visual.append(zoom);
      const dialog = document.createElement("dialog");
      dialog.className = "hc-drawing-dialog";
      dialog.setAttribute("aria-label", host.dataset.zoomLabel);
      const close = document.createElement("button");
      close.type = "button";
      close.className = "hc-drawing-close";
      close.textContent = host.dataset.closeLabel;
      dialog.append(close);
      host.append(dialog);
      zoom.addEventListener(
        "click",
        () => {
          dialog.append(stage);
          dialog.showModal();
          host.update();
        },
        options,
      );
      close.addEventListener("click", () => dialog.close(), options);
      dialog.addEventListener(
        "close",
        () => {
          visual.prepend(stage);
          host.update();
          zoom.focus({ preventScroll: true });
        },
        options,
      );
      if (bar) {
        bar.classList.add("hom");
        document.body.append(bar);
      }
      let frame = 0;
      const position = () => {
        frame = 0;
        const rect = host.getBoundingClientRect();
        const editing = Boolean(activeInput());
        host.classList.toggle("hc-mobile-editing", editing);
        const header = document.querySelector("header");
        const headerRect = header?.getBoundingClientRect();
        const top =
          headerRect && headerRect.top <= 0 && headerRect.bottom > 0
            ? Math.min(headerRect.bottom, 120)
            : 0;
        host.style.setProperty("--hc-mobile-top", top + "px");
        bar?.classList.toggle(
          "is-visible",
          media.matches &&
            !editing &&
            !dialog.open &&
            rect.top < innerHeight &&
            rect.bottom > 0,
        );
      };
      const schedule = () => {
        if (!frame) frame = requestAnimationFrame(position);
      };
      const layout = () => {
        if (dialog.open) dialog.close();
        if (media.matches) {
          controls.append(orderSummary);
          groups.forEach((g, i) => (g.details.open = i === 0));
        } else {
          visual.append(orderSummary);
          groups.forEach((g) => (g.details.open = true));
        }
        schedule();
      };
      // Let the browser reveal focused inputs without repeated forced centering.
      window.addEventListener("scroll", schedule, {
        passive: true,
        signal: abort.signal,
      });
      window.addEventListener("resize", schedule, options);
      window.visualViewport?.addEventListener("resize", schedule, options);
      host.addEventListener("focusin", schedule, options);
      host.addEventListener("focusout", schedule, options);
      media.addEventListener("change", layout, options);
      layout();
      return {
        update(s) {
          const labels = [
            choiceLabel("edges"),
            choiceLabel("finish"),
            choiceLabel(s.lighting === "yes" ? "lightingType" : "lighting"),
          ].filter(Boolean);
          const text = labels.join(" · ");
          if (choices.textContent !== text) choices.textContent = text;
          for (const { card, selection } of groups) {
            if (card.querySelector('[name="length"]'))
              selection.textContent = `${s.length} × ${s.depth} × ${s.thickness} mm`;
            else if (card.querySelector("[data-wood-link]"))
              selection.textContent =
                card
                  .querySelector('[aria-current="page"]')
                  ?.textContent.trim() || "";
            else {
              const checked = [
                ...card.querySelectorAll("input:checked"),
              ].filter((input) => !input.disabled);
              selection.textContent = checked
                .map((input) => input.closest("label")?.textContent.trim())
                .filter(Boolean)
                .join(" · ")
                .replace(/\s+/g, " ")
                .slice(0, 120);
            }
          }
          schedule();
        },
        disconnect() {
          abort.abort();
          cancelAnimationFrame(frame);
          if (dialog.open) dialog.close();
          visual.prepend(stage);
          zoom.remove();
          choices.remove();
          dialog.remove();
          if (bar) host.append(bar);
          for (const { details, card } of groups) {
            details.before(card);
            details.remove();
          }
        },
      };
    },
  };
})();
